import {API_URL, CMS_URL, THEME_COLOR} from "../constant"
import React from 'react';
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick"
import { BrowserRouter as Router, Link } from 'react-router-dom';
import InfiniteScroll from "react-infinite-scroller";

import banner1 from "../images/replicate/top-5-september/Top 5 Promo Sept E-Commerce - 1.jpg"
import banner2 from "../images/replicate/top-5-september/Top 5 Promo Sept E-Commerce - 2.jpg"
import banner3 from "../images/replicate/top-5-september/Top 5 Promo Sept E-Commerce - 3.jpg"
import banner4 from "../images/replicate/top-5-september/Top 5 Promo Sept E-Commerce - 4.jpg"
import banner5 from "../images/replicate/top-5-september/Top 5 Promo Sept E-Commerce - 5.jpg"
import banner6 from "../images/Website Banner 1400 x 600 px Brosur Sept 2022.jpg"
import BCC from "../images/banner bcc.jpg"

import KITCHEN from "../images/Category/KITCHEN.png";
import SERVING from "../images/Category/SERVING.png";
import STORAGE from "../images/Category/STORAGE.png";
import READYTOGO from "../images/Category/READY TO GO.png";
import KIDS from "../images/Category/KIDS.png";

import "./Home.css";


class Home extends React.Component{

    constructor(props){
        super(props)

        const search = props.location.search;
        const wh = new URLSearchParams(search).get('wh');
        if(wh && wh !== "")
            localStorage.setItem("wh", wh);

        this.state= {
            promos: [],
            categories : [],
            banners : [],
            itemPage : 0,
            hasMore: true,
            items: [],
            isLoading: false,
            bandungParticipant: false,
            token: localStorage.getItem("token"),
            categoryImages :{
                "KITCHEN": KITCHEN,
                "SERVING": SERVING,
                "STORAGE": STORAGE,
                "READY TO GO": READYTOGO,
                "KIDS": KIDS,
            },
        }
    }

    async componentDidMount(){
        let banners = await this.getBanner();
        banners = JSON.parse(banners)
        if(banners.status === 200){
            this.setState({
                banners: banners.data
            })
        }

        let categories = await this.getCategory();
        categories = JSON.parse(categories)
        if(categories.status === 200){
            this.setState({
                categories: categories.data
            })
        }

        let promos = await this.getPromo();
        if(promos.status === 200){
            this.setState({
                promos: promos.data
            })
        }

        let promobandung = await this.getPromoBandung();
        if(promobandung.status === 200){
            this.setState({bandungParticipant: promobandung.data.bandungParticipant})
        }
    }

    getPromoBandung(){

        var myHeaders = new Headers();
        myHeaders.append("x-access-token", ((this.state.token) ? this.state.token : "").replaceAll("\"","").replaceAll("\'",""));
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };
          
        return fetch(`${API_URL}api/promo/bandung`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', error));

    }

    getBanner(){
        var requestOptions = {
            method: 'GET',
            redirect: 'follow'
        };
          
        return fetch(`${API_URL}api/banner`, requestOptions)
        .then(response => response.text())
        .catch(error => console.log('error', error));
    }

    getCategory(){
        var requestOptions = {
            method: 'GET',
            redirect: 'follow'
        };
          
        return fetch(`${API_URL}api/item/category`, requestOptions)
        .then(response => response.text())
        .catch(error => console.log('error', error));

    }

    getPromo(){
        var requestOptions = {
            method: 'GET',
            redirect: 'follow'
        };
          
        return fetch(`${API_URL}api/promocategory`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', error));

    }

    numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }

    async loadMore(){
        if(!this.state.isLoading){
            await this.setState({
                itemPage: this.state.itemPage+1,
                // hasMore: false,
                isLoading: true
            })
            var myHeaders = new Headers();
            myHeaders.append("x-wh", localStorage.getItem("wh"));

            var urlencoded = new URLSearchParams();
    
            var requestOptions = {
                method: 'GET',
                // body: urlencoded,
                headers: myHeaders,
                redirect: 'follow'
            };
    
            fetch(`${API_URL}api/item/${this.state.itemPage}/10`, requestOptions)
            .then(response => response.json())
            .then(res=>{
                let items = this.state.items;
                res.data.map((value, index)=>{
                    let imgurl = `${CMS_URL}/images/no-image-found.jpg`;
                    if(value.ImageName){
                        imgurl = `${CMS_URL}/images/upload/product/${value.Code}/${value.ImageName}`;
                    }
                    items.push(
                        <div className="home-item" key={value.ItemUnitID}>
                            <Link to={`/item/${value.ItemUnitID}`} className="black-text">
                                <div style={{position:"relative", width:"100%", paddingTop:"100%"}}>
                                    <img className="home-item-image" src={imgurl} />
                                </div>
                                <div style={{flex:"1 0 auto", display:"flex", flexDirection:"column", padding:".625rem",overflow:"hidden"}}>
                                    <div style={{flex:"1 0 auto", display:"flex", flexDirection:"column", padding:".625rem",overflow:"hidden"}}>
                                        <div style={{flexGrow: "1", minHeight: "1.75rem"}}>
                                            <div className="home-item-title">{value.Name}</div>
                                        </div>
                                    </div>
                                    <div className="home-item-detail">
                                        <div className="home-item-price">
                                            <span style={{fontSize:".75rem",color:`${THEME_COLOR}`}}>Rp</span>
                                            <span style={{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",fontSize:"1rem",color:THEME_COLOR}}>{this.numberWithCommas(value.CatalogPrice)}</span>
                                        </div>
                                        <div className="home-item-sold">{value.Sales} Sold</div>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    )
                })
                this.setState({
                    items: items,
                    isLoading: false
                })
            })
            .catch(error => {
                this.setState({isLoading: false})
            });
        }
    }

    render(){
        const settingsCategory = {
            dots: true,
            infinite: false,
            arrows: false,
            className: "category-slider",
            // speed: 500,
            slidesToShow: 4,
            slidesToScroll: 3,
        };
        const settingsPromo = {
            dots: true,
            infinite: false,
            arrows: false,
            className: "category-slider",
            // speed: 500,
            slidesToShow: 3,
            slidesToScroll: 3
        };
        const settingsBanner = {
            dots: true,
            autoplay: true,
            infinite: true,
            arrows: true,
            className: "banner-slider",
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1
        };
      
        return(
            <React.StrictMode>
                {/* <Header /> */}
                <div className="">
                    <div className="home-container">
                        <Slider {...settingsBanner}>
                            {
                                this.state.banners.map((value, index) => {
                                    return (<div>
                                        {
                                            (value.Type == 1) ?(
                                                <Link to={`${value.Link}`}>
                                                    <img src={`${CMS_URL}/images/upload/banner/${value.Image}`} class="banner-image" />
                                                </Link>
                                            ):(
                                                <a href={`${value.Link}`} target="_blank">
                                                    <img src={`${CMS_URL}/images/upload/banner/${value.Image}`} class="banner-image" />
                                                </a>
                                            )
                                        }
                                    </div>)
                                })
                            }
                            {/* <div>
                                <Link to="/promo/3170">
                                    <img src={banner2} class="banner-image"/>
                                </Link>
                            </div>
                            <div>
                                <Link to="/promo/3171">
                                    <img src={banner3} class="banner-image" />
                                </Link>
                            </div>
                            <div>
                                <Link to="/promo/3163">
                                    <img src={banner4} class="banner-image"/>
                                </Link>
                            </div>
                            <div>
                                <Link to="/promo/3165">
                                    <img src={banner5} class="banner-image" />
                                </Link>
                            </div>
                            <div>
                                <Link to="/Brochure/BROSUR_SEPTEMBER_2022.pdf" target={`_blank`}>
                                    <img src={banner6} class="banner-image" />
                                </Link>
                            </div> */}
                        </Slider>
                    </div>
                    <div style={{margin: "50px"}}></div>
                    {/* <hr /> */}
                    <div className="home-container">
                        {/* <h5>Category</h5>
                        <Slider {...settingsCategory}>
                            {
                                this.state.categories.map((value, index) => {
                                    // var b64 = new Buffer(value.Image.data).toString('base64')
                                    // var imgurl = `data:image/png;base64,${b64}`

                                    return (
                                        <Link to={`/search?c=${value.ID}`} className="black-text">
                                            <div key={`catagory-${index}`} className="image-icon">
                                                <img src={this.state.categoryImages[value.Code]} style={{width: "100%"}} />
                                                <p className="center">{value.Name}</p>
                                            </div>
                                        </Link>
                                    )
                                })
                            }
                        </Slider> */}
                        <h5>Category</h5>
                        <div className="temp-category-container">
                            <div className="row">
                                {
                                    this.state.categories.map((value, index) => {
                                        // var b64 = new Buffer(value.Image.data).toString('base64')
                                        // var imgurl = `data:image/png;base64,${b64}`

                                        return (
                                            <Link to={`/search?c=${value.ID}`} className="black-text col s4">
                                                <div key={`catagory-${index}`} className="" style={{padding: "0 10px", width:"100px"}}>
                                                    <img src={`${CMS_URL}/images/upload/itemcategory/${value.ImageName}`} style={{width: "100%"}} />
                                                    <p className="center">{value.Name}</p>
                                                </div>
                                            </Link>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                    <div style={{margin: "50px"}}></div>
                    {
                        (this.state.promos.length > 0)?(
                            <div className="home-container">
                                <h5>Promo</h5>
                                <Slider {...settingsPromo}>
                                    {
                                        // (this.state.bandungParticipant) ? (
                                            
                                        //     <Link to={`/bcc`} className="black-text">
                                        //         <div key={`promo-0`} className="image-icon">
                                        //             <img src={BCC} />
                                        //             <p className="center">PROMO BANDUNG CONFERENCE CHALLENGE</p>
                                        //         </div>
                                        //     </Link>
                                        // ): <div style={{display:"none"}}></div>
                                    }
                                    {
                                        this.state.promos.map((value, index) => {
                                            return (
                                                <Link to={`/searchpromo?c=${value.ID}`} className="black-text">
                                                    <div key={`promo-${index+1}`} className="image-icon-promo" >
                                                        <img src={`${CMS_URL}/images/upload/promocategory/${value.Image}`}/>
                                                        <p className="center">{value.Name}</p>
                                                    </div>
                                                </Link>
                                            )
                                        })
                                    }
                                </Slider>
                            </div>
                        ):(
                            <></>
                        )
                    }
                    <div style={{margin: "50px"}}></div>
                    <h5>Popular Item</h5>
                    <InfiniteScroll
                        pageStart={this.state.itemPage}
                        loadMore={this.loadMore.bind(this)}
                        hasMore={this.state.hasMore}
                        loader={<div style={{width: "100%"}}>loading...</div>}
                        children={``}
                    >
                        <div className="" style={{display:"flex",flexWrap:"wrap",paddingBottom:"80px"}}>
                            {this.state.items}
                        </div>
                    </InfiniteScroll>
                </div>
                <Footer />
            </React.StrictMode>
        );
    }
}

export default Home;
